import { render, staticRenderFns } from "./MailsDatas.vue?vue&type=template&id=b61fdc62&"
import script from "./MailsDatas.vue?vue&type=script&lang=js&"
export * from "./MailsDatas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports